module.exports = __webpack_public_path__ + "static/media/case-id-tooltip-de.12c4bdf0.jpg";